import React from 'react';
import PropTypes from 'prop-types';

import { ButtonV2, CircleIcon } from '@zola/zola-ui';
import { WeddingWebsites } from '@zola/zola-ui/src/assets/images/icons';
import { isMobile } from 'lib/responsive';

import css from 'stylesheets/common/_modal.module.less';
import PageList from './PageList';

function PagesVisibility({ pages, orderedIds, onPublishWebsite, onTogglePage }) {
  const pageCount = Object.values(pages).length;
  const fullWidth = isMobile();
  return (
    <React.Fragment>
      <div>
        <CircleIcon image={WeddingWebsites} variant="cream" size={100} className="circleIcon" />
        {pageCount === 1 && (
          <>
            <h3 className={css.title}>We Hid This Empty Page for You</h3>
            <p className={css.subtitle}>
              You can still make your website visible without this page and add it back anytime.
            </p>
          </>
        )}
        {pageCount !== 1 && (
          <>
            <h3 className={css.title}>We Hid These Empty Pages for You</h3>
            <p className={css.subtitle}>
              You can still make your website visible without these and add them back anytime.
            </p>
          </>
        )}
      </div>
      <div className={css.body}>
        <PageList pages={pages} orderedIds={orderedIds} onToggle={onTogglePage} />
      </div>
      <div className={css.footer}>
        <ButtonV2 className="hide-btn-cta" onClick={onPublishWebsite} fullWidth={fullWidth}>
          Make Website Visible
        </ButtonV2>
      </div>
    </React.Fragment>
  );
}

PagesVisibility.propTypes = {
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  onPublishWebsite: PropTypes.func.isRequired,
  onTogglePage: PropTypes.func.isRequired,
};

export default PagesVisibility;



// WEBPACK FOOTER //
// ./src/components/manage/common/HidePagesModal/PageVisiblity.jsx